import { createReducer } from '@reduxjs/toolkit';
import { FailureGradeStoreState } from '@Types/failureGrade.types';
import {
	getFailureGradeMatrixAction,
	getFailureGradeMatrixRejected,
	getFailureGradeMatrixResolved,
	updateFailureGradeMatrixRanges,
	updateFailureGradeMatrixRangesResolved,
	updateFailureGradeMatrixRangesRejected,
	updateFailureMatrixGrade,
	updateFailureMatrixGradeResolved,
	updateFailureMatrixGradeRejected,
} from '@Actions';

export const initState: FailureGradeStoreState = {
	inProcess: false,
	successful: null,
	failureGradeMatrixResult: null,
	latestRunResultId: null,
};

export const reducer = createReducer(initState, builder => {
	builder
		.addCase(getFailureGradeMatrixAction, state => {
			state.inProcess = true;
			state.successful = null;
			state.failureGradeMatrixResult = null;
		})
		.addCase(getFailureGradeMatrixResolved, (state, action) => {
			state.inProcess = false;
			state.successful = true;
			state.failureGradeMatrixResult = action.payload.failure_grade_config;
			state.latestRunResultId = action.payload.latestRunResultId;
		})
		.addCase(getFailureGradeMatrixRejected, state => {
			state.inProcess = false;
			state.successful = false;
			state.failureGradeMatrixResult = null;
			state.latestRunResultId = null;
		})
		.addCase(updateFailureGradeMatrixRanges, state => {
			state.inProcess = true;
		})
		.addCase(updateFailureGradeMatrixRangesResolved, (state, action) => {
			state.inProcess = false;
			state.successful = true;
			state.failureGradeMatrixResult = action.payload.failure_grade_config;
		})
		.addCase(updateFailureGradeMatrixRangesRejected, state => {
			state.inProcess = false;
			state.successful = false;
			state.failureGradeMatrixResult = null;
		})
		.addCase(updateFailureMatrixGrade, state => {
			state.inProcess = true;
		})
		.addCase(updateFailureMatrixGradeResolved, (state, action) => {
			state.inProcess = false;
			state.successful = true;
			state.failureGradeMatrixResult = action.payload.failure_grade_config;
		})
		.addCase(updateFailureMatrixGradeRejected, state => {
			state.inProcess = false;
			state.successful = false;
			// Don't clear modelId here since it's just a single cell update failure
		});
});

export default reducer;
